import { topAnime } from "@/mocks/anime";

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
              <i className="ri-trophy-line" />
              热门番剧排行榜
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              本周热度与口碑综合榜 · TOP 10
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              榜单由本站编辑部综合近期讨论热度、观众口碑与作品完成度整理，评分统一标注为「编辑评分」，
              仅作选番参考。排名越靠前，代表近期被提及和讨论的频率越高。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-refresh-line" />
            榜单每周更新一次
          </div>
        </div>

        <ol className="flex flex-col divide-y divide-background-200 border-y border-background-200" data-product-shop>
          {topAnime.map((item) => (
            <li key={item.rank} className="group py-4 md:py-5">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="flex flex-col items-center shrink-0 w-9 md:w-12">
                  <span
                    className={`font-heading text-2xl md:text-3xl font-semibold leading-none ${
                      item.rank <= 3 ? "text-primary-500" : "text-foreground-300"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="mt-1 text-[10px] text-foreground-400">TOP</span>
                </div>

                <div className="w-16 h-24 md:w-20 md:h-28 shrink-0 rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={item.poster}
                    alt={`${item.title} 作品海报`}
                    title={`${item.title} 动漫推荐`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 rounded-full text-[11px] bg-secondary-100 text-secondary-900">
                      {item.genre}
                    </span>
                    <span className="text-[11px] text-foreground-500">{item.episodes}</span>
                  </div>

                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3 md:line-clamp-2">
                    {item.summary}
                  </p>

                  <div className="mt-2.5 flex flex-wrap items-center gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-md text-[11px] bg-background-100 text-foreground-600 border border-background-200"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="shrink-0 text-right hidden sm:block">
                  <p className="font-heading text-xl font-semibold text-accent-600">{item.score}</p>
                  <p className="text-[10px] text-foreground-400 mt-0.5">编辑评分</p>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <p className="mt-5 text-xs text-foreground-500 flex items-center gap-1.5">
          <i className="ri-information-line" />
          提示：评分与排名为主观编辑部指数，不同观众口味差异较大，请结合自身偏好判断。
        </p>
      </div>
    </section>
  );
}